import "./RoomsListing.css";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import ActionConfirmation from "../../../../Components/ActionConfirmation/ActionConfirmation";
import RoomsListingViewModel from "./RoomsListingViewModel";
import { PulseLoader } from "react-spinners";
import { ToastContainer } from "react-toastify";
import NoDataFound from "../../../../Components/NoDataFound/NoDataFound";

const RoomsListing = () => {
  const {
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    RoomsArray,
    IsLoading,
  } = RoomsListingViewModel();
  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper admin-rooms-listing-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Hostel</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">Dashboard</a>
                  </li>
                  <li className="breadcrumb-item active">Hostel</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="page-title">Hostel</h3>
                      </div>
                      <div className="col-auto text-end float-end ms-auto download-grp">
                        <Link
                          to={`/user/admin/hostel/add`}
                          className="btn btn-primary"
                        >
                          <i className="fas fa-plus" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  {IsLoading ? (
                    <PulseLoader
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      color="#3D5EE1"
                      size={16}
                    />
                  ) : (
                    <div className="table-responsive">
                      <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                        <thead className="student-thread">
                          <tr>
                            <th>Hostel Name</th>
                            <th>Block</th>
                            <th>Room No</th>
                            <th>Room Type</th>
                            <th>Total Beds</th>
                            <th>Beds Available</th>
                            <th>Cost Per Bed</th>
                            <th>Availability</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {RoomsArray &&
                            RoomsArray.map((item, index) => {
                              const ArrayOfWords = item?.HostelName.split(" ");
                              for (var i = 0; i < ArrayOfWords.length; i++) {
                                ArrayOfWords[i] =
                                  ArrayOfWords[i].charAt(0).toUpperCase() +
                                  ArrayOfWords[i].slice(1);
                              }
                              const StringOfWords = ArrayOfWords.join(" ");
                              return (
                                <tr key={index}>
                                  <td>{StringOfWords}</td>
                                  <td>{item?.Block ? item?.Block : "---"}</td>
                                  <td>{item?.RoomNumber}</td>
                                  <td>{item?.RoomType}</td>
                                  <td>{item?.TotalBeds}</td>
                                  <td>{item?.BedsAvailable}</td>
                                  <td>{item?.CostPerBed}</td>
                                  <td>
                                    {item?.TotalBeds === item?.BedsAvailable ? (
                                      <span className="badge badge-success">
                                        Room Available
                                      </span>
                                    ) : item?.BedsAvailable ? (
                                      <span className="badge badge-warning">
                                        {item?.BedsAvailable} Bed Available
                                      </span>
                                    ) : item?.BedsAvailable === 0 ? (
                                      <span className="badge badge-danger">
                                        Full
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                  <td className="text-end">
                                    <div className="actions ">
                                      <Link
                                        onClick={() => {
                                          handleOpenDeleteDialog(item?.id);
                                        }}
                                        className="btn btn-sm bg-success-light me-2 "
                                      >
                                        <i className="fa-regular fa-trash-can"></i>
                                      </Link>
                                      <Link
                                        to={`/user/admin/hostel/update/${item?.id}`}
                                        className="btn btn-sm bg-danger-light"
                                      >
                                        <i className="fa-regular fa-pen-to-square"></i>
                                      </Link>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                      {RoomsArray?.length <= 0 && <NoDataFound />}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}

      <ActionConfirmation
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this room?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />

      <ToastContainer />
    </Fragment>
  );
};

export default RoomsListing;
